import { APIService } from '@apparel/core/api/APIService';
import { AxiosInstance, AxiosRequestConfig } from 'axios';

export { HTTPCodes } from './httpCodes';

/**
 * Create an api endpoint
 * @param baseURL
 * @param axiosConfig
 */
export const createEndpoint = (baseURL: string, axiosConfig: AxiosRequestConfig = {}): AxiosInstance =>
    APIService.createHTTP(`${baseURL.replace(/^/g, '')}`, axiosConfig);

export const BaseRequest = APIService.createHTTP('/');
export const http = APIService.createHTTP('/api');
export const api = http;
